import { Registration } from '@stax-core/types-omni';

export const priorityMapper = (r: Registration) => ({});
